import React from 'react';
import { Icon } from './Icon.js';
export const IconPenWriting4 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 21H20C21.1046 21 22 20.1046 22 19C22 17.8954 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15C2 13.8954 2.89543 13 4 13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 13L20.5 5.50002L16.5 1.50008L8.99999 9.00001L8.99999 13L13 13Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconPenWriting4.js.map